import type { Filter } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { ResultsSkipLink } from '../results/ResultsSkipLink';
import { StandardFilter } from './StandardFilter';
import { TaxonomyFilter } from './TaxonomyFilter';
import { CategoryFilter } from './category/CategoryFilter';
import { QueryFilter } from './query/QueryFilter';
import { RangeFilter } from './range/RangeFilter';

const filterScrollStyle: React.CSSProperties = {
    scrollMarginTop: '50px',
};

type FilterItemProps = {
    filter: Filter;
    filterAction: (
        filterElement: HTMLDivElement | null,
        filterName: string,
    ) => void;
};

export function FilterItem(props: FilterItemProps) {
    const { filter, filterAction } = props;

    const isCategoryFilter = filter.name === 'category';
    const hasMultiLevelFilterItems = filter.filter_items.some(
        (item) => item.filter_items && item.filter_items.length > 0,
    );

    const filterActionFn = React.useCallback(
        (ele: HTMLDivElement | null) => filterAction(ele, filter.name),
        [filter, filterAction],
    );

    return (
        <div ref={filterActionFn} style={filterScrollStyle}>
            <h3 className="h5">{filter.display_name}</h3>
            {filter.type === 'QUERY_FILTER' && <QueryFilter filter={filter} />}
            {filter.type === 'RANGE_FILTER' && <RangeFilter filter={filter} />}
            {filter.type === 'STANDARD_FILTER' && isCategoryFilter && (
                <CategoryFilter filter={filter} />
            )}
            {filter.type === 'STANDARD_FILTER' &&
                !isCategoryFilter &&
                hasMultiLevelFilterItems && <TaxonomyFilter filter={filter} />}
            {filter.type === 'STANDARD_FILTER' &&
                !isCategoryFilter &&
                !hasMultiLevelFilterItems && <StandardFilter filter={filter} />}
            <ResultsSkipLink inline={true} />
        </div>
    );
}
